module.exports = __webpack_public_path__ + "assets/img/nav_bg4.fedc41b8.png";